// extracted by mini-css-extract-plugin
module.exports = {"border":"payments_border___wbRE","row":"payments_row__AQmNf"};